/* global listUsersUrl listAccountsUrl deleteEventsUrl deleteOrganisationUrl eventHomeUrl featureEventDeletion */

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import AccountsTable from './AccountsTable';

function Accounts(props) {
    useEffect(() => {}, []);

    return (
        <AccountsTable
            fetchUsersUrl={listUsersUrl}
            fetchAccountsUrl={listAccountsUrl}
            deleteEventsUrl={deleteEventsUrl}
            deleteOrganisationUrl={deleteOrganisationUrl}
            eventHomeUrl={eventHomeUrl}
            featureEventDeletion={featureEventDeletion}
        />
    );
}

export default Accounts;
if (document.getElementById('AdminAccounts')) {
    var rootEl = document.getElementById('AdminAccounts');
    ReactDOM.render(
        <App>
            <Accounts />
        </App>,
        rootEl,
    );
}
